import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader, Tooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { Intent } from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";
import { MAP_INTENT_TO_CHIPDOWN_TEXT } from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";
import { translate } from "app/filters/i18nFilter";

import { IntentTooltip } from "./IntentTooltip";

export const KeywordIntent = ({
    keyword,
    intent,
    isLoading,
}: {
    keyword: string;
    intent: string | undefined;
    isLoading: boolean;
}) => {
    const intentText =
        MAP_INTENT_TO_CHIPDOWN_TEXT[intent as keyof typeof MAP_INTENT_TO_CHIPDOWN_TEXT] ?? translate("common.n/a");

    const tooltipStyle = {
        style: {
            background: colorsPalettes.carbon[0],
            width: "220px",
        },
    };
    return (
        <Flex
            boxSizing="border-box"
            height="100%"
            padding="0 0 28px"
            justifyContent="center"
            alignItems="center"
            gap="4px"
            flex="1 0 0"
            alignSelf="stretch"
        >
            {isLoading ? (
                <PixelPlaceholderLoader
                    height={56}
                    width={240}
                />
            ) : (
                <Tooltip
                    content={
                        <IntentTooltip
                            keyword={keyword}
                            intentType={intent as Intent}
                        />
                    }
                    placement="right"
                    enabled={!!intent}
                    {...tooltipStyle}
                >
                    <Text
                        as="div"
                        fontVariant="h1"
                        color={colorsPalettes.carbon[500]}
                    >
                        {intentText}
                    </Text>
                </Tooltip>
            )}
        </Flex>
    );
};
